import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import DaHero from "./components/DaHero";
import DaServices from "./components/DaServices";
import DaWhyChoose from "./components/DaWhyChoose";
import DaProcess from "./components/DaProcess";
import DaTestimonials from "./components/DaTestimonials";
import DaFaq from "./components/DaFaq";
import DaCta from "./components/DaCta";
import "./data-analytics.css";

const DataAnalyticsPage: React.FC = () => {
  useEffect(() => {
    document.title = "Data Analytics Services | WebTech Bangalore";

    const description =
      "Transform raw data into actionable insights with BI dashboards, predictive analytics, and AI. Expert data analytics services by WebTech Bangalore.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="da-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <DaHero />
            <DaServices />
            <DaWhyChoose />
            <DaProcess />
            <DaTestimonials />
            <DaFaq />
            <DaCta />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default DataAnalyticsPage;
